<template>
  <div class="content">
    <h1 class="content__title">Lista de Imágenes de Galería</h1>
    <span class="content__details">Listado de imágenes de galerías, pueden ser utlizadas para Sliders, banners o galerías de imágenes simples.</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Imágenes</h2>
          <div class="main__results">
            <div class="result" v-if="images === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!images">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(image, index) in images" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="'Nombre: ' + image.name"></h2>
                <p class="result__detail" v-text="'Tipo: ' + image.gallery"></p>
                <p class="result__detail" v-text="'Título: ' + image.title_es"></p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'galleryImageEdit', params: {gallery_id: $route.params.gallery_id, id: image.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteImage(image.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryList', params: {page: 1}}">Lista de Galerías</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'galleryImageNew'}">Nueva Imagen</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      confirm: false,
      gallery_id: null,
      images: 'loading',
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.gallery_id = this.$route.params.gallery_id
    this.getImages()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.gallery_id = this.$route.params.gallery_id
      this.getImages()
    }
  },
  methods: {
    deleteImage: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'gallery_images'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getImages()
            this.$store.commit('notificate', {
              title: 'IMAGEN BORRADA',
              text: 'La imagen ha sido borrada correctamente.',
              type: 'success'
            })
          }
        )
    },
    getImages: function () {
      let httpRequest = {
        module: 'gallery_images',
        params: '?fields=name,title_es,id,gallery&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination&gallery_id=eq:' + this.gallery_id
      }
      this.get(httpRequest)
        .then(
          images => {
            this.images = images.data
            this.pagination.pages = images.pagination.pages
            this.pagination.currentPage = images.pagination.current_page
            this.pagination.results = images.pagination.results
          }
        )
        .catch(
          () => {
            this.images = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'galleryImageList', params: {page: this.page - 1}})
            }
          }
        )
    }
  }
}
</script>

<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
</style>



// WEBPACK FOOTER //
// src/components/galleries/image.list.vue